import React from "react";
import { useTheme } from "@emotion/react";
import {
  BottomNavigation,
  BottomNavigationAction,
  styled,
} from "@mui/material";
import { Box } from "@mui/system";
import SwipeableViews from "react-swipeable-views";

import { ModalTab } from "./ModalTab/ModalTab";
import TableBox from "./Table";
import ProfileOpinionBox from "./Opinion/ProfileOpinionBox";
import ProfileDiscussionBox from "./Discussion/ProfileDiscussionBox";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingState,
  setProfileTab,
} from "../../../../redux/features/settingSlice";

const StyleBottomNav = styled(BottomNavigationAction)(({ theme }) => ({
  "&.MuiBottomNavigationAction-root": {
    borderRadius: "7px",
    paddingTop: "3px",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.palette.black.main,
    minWidth: "50%",
  },
  "&.MuiBottomNavigationAction-root.Mui-selected": {
    backgroundColor: theme.palette.black.main,
    color: theme.palette.white.main,
    fontWeight: 700,
  },
}));

const ProfileTabs = ({ data }) => {
  const theme = useTheme();
  const { profileTab } = useSelector(getSettingState);
  const dispatch = useDispatch();

  const swipeHandleChangeTab = (index) => {
    dispatch(setProfileTab(index));
  };

  const handleChangeTab = (event, newValue) => {
    dispatch(setProfileTab(newValue));
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderColor: theme.palette.black.main,
        borderRadius: "16px 16px 0px 0px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Nav Button  */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: theme.palette.white.main,
          position: "sticky",
          top: "62px",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: "16px 16px 0px",
            borderRadius: "16px 16px 0px 0px",
            borderTop: "2px solid",
            borderRight: "2px solid",
            borderLeft: "2px solid",
            backgroundColor: theme.palette.white.main,
            pb: "14px",
          }}
        >
          <BottomNavigation
            sx={{
              height: "48px",
              boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
              borderRadius: "8px",
              fontSize: "16px",
            }}
            value={profileTab}
            onChange={handleChangeTab}
          >
            <StyleBottomNav value={0} icon={"Thoughts"} />
            <StyleBottomNav value={1} icon={"Tables"} />
          </BottomNavigation>
        </Box>
      </Box>

      <SwipeableViews
        style={{
          width: "100%",
          height: "100%",
          padding: "0 16px ",
          borderRight: "2px solid",
          borderLeft: "2px solid",
          paddingTop: "14px",
        }}
        index={profileTab}
        onChangeIndex={swipeHandleChangeTab}
      >
        <ModalTab value={profileTab} index={0}>
          <ProfileOpinionBox data={data} />
          <ProfileDiscussionBox data={data} />
        </ModalTab>
        <ModalTab value={profileTab} index={1}>
          <TableBox data={data} />
        </ModalTab>
      </SwipeableViews>
    </Box>
  );
};

export default ProfileTabs;
